module.exports = __webpack_public_path__ + "img/29_Liturghierul_din_Feleac.ae8ee466.jpg";